import { useState, useEffect } from "react";
import axios from "axios";

const token = "c2W1upHDo1S71WQtJ07fVuiGLAuYHo"
const ics = [188, 189, 190, 192, 191, 201, 197, 193, 199, 198, 196, 195, 194]


function useFetchProgramsHindi(url){
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
    if (!url) return;

    const controller = new AbortController();

    async function fetchData() {
        try {
            const requests = ics.map(id =>
                axios.get(`${url}/${id}`, {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    'no-encryption': 'True'
                    },
                    signal: controller.signal
                })
            );

            const responses = await Promise.all(requests);
            const results = responses
            .map(res => res.data?.data);

            setData(results);
        } catch (err) {
            if (!axios.isCancel(err)) {
            setError(err.message || 'Error fetching data');
            }
        }
    }

    fetchData();

    return () => controller.abort();
  }, [url]);

  return { data, error };
}

export default useFetchProgramsHindi